<template>
  <div class="guarantor-edit">
    <Row :gutter="16">
      <i-col span="14">
        <Form ref="editForm" :model="guarantorModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="guarantorModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="社会信用代码" prop="businessLicense">
            <Input v-model="guarantorModel.businessLicense" placeholder="输入社会信用代码" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <Select v-model="guarantorModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="营业地址" prop="address">
            <Input v-model="guarantorModel.address" placeholder="输入营业地址" />
          </FormItem>
          <Form-item label="邮编" prop="postCode">
            <Input v-model="guarantorModel.postCode" placeholder="请输入邮编" style="width: 120px"></Input>
          </Form-item>
          <Form-item label="注册资金(万元)" prop="capital">
            <Input-number :min="0" :step="100" v-model="guarantorModel.capital"></Input-number>
          </Form-item>
          <Form-item label="企业建立日期" prop="estDate">
            <Date-picker type="date" v-model="guarantorModel.estDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
          </Form-item>
          <Form-item label="经营范围" prop="scope">
            <Input v-model="guarantorModel.scope" placeholder="请输入经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item>
          <Form-item label="公司网址" prop="homePage">
            <Input v-model="guarantorModel.homePage" placeholder="请输入公司网址">
              <span slot="prepend">http://</span>
            </Input>
          </Form-item>
          <Form-item label="电子邮箱" prop="email">
            <Input v-model="guarantorModel.email" placeholder="请输入电子邮箱"></Input>
          </Form-item>
          <Form-item label="联系人">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="contact">
                    <Input v-model="guarantorModel.contact" placeholder="联系人姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="电话" prop="contactTel">
                    <Input v-model="guarantorModel.contactTel" placeholder="联系人电话"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="传真" prop="fax">
                    <Input v-model="guarantorModel.fax" placeholder="联系人传真"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div>
          </Form-item>
          <Form-item label="法定代表人">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="legalPersonName">
                    <Input v-model="guarantorModel.legalPersonName" placeholder="公司法人姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职务" prop="legalPersonRole">
                    <Input v-model="guarantorModel.legalPersonRole" placeholder="法人职务"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职称" prop="legalPersonTitle">
                    <Input v-model="guarantorModel.legalPersonTitle" placeholder="法人职称"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div>
          </Form-item>
          <Form-item label="总经理">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="8">
                  <Form-item label="姓名" prop="generalManagerName">
                    <Input v-model="guarantorModel.generalManagerName" placeholder="总经理姓名"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职务" prop="generalManagerRole">
                    <Input v-model="guarantorModel.generalManagerRole" placeholder="总经理职务"></Input>
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item label="职称" prop="generalManagerTitle">
                    <Input v-model="guarantorModel.generalManagerTitle" placeholder="总经理职称"></Input>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div>
          </Form-item>
          <Form-item label="员工" prop="EmployeeTotal">
            <div class="form-item-bordered-box ivu-form-label-top">
              <Row>
                <Col span="6">
                  <Form-item label="员工总数" prop="employeeTotal">
                    <Input-number :min="0" v-model="guarantorModel.employeeTotal" placeholder="请输入员工总数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="有职称" prop="titledTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledTotal" placeholder="请输入有职称人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="中级职称" prop="titledMedTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledMedTotal" placeholder="请输入中级职称人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="高级职称" prop="titledSeniorTotal">
                    <Input-number :min="0" v-model="guarantorModel.titledSeniorTotal" placeholder="请输入高级职称人数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="有执业资格" prop="qualifiedTotal">
                    <Input-number :min="0" v-model="guarantorModel.qualifiedTotal" placeholder="请输入有执业资格人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册监理工程师" prop="regSupervTotal">
                    <Input-number :min="0" v-model="guarantorModel.regSupervTotal" placeholder="请输入注册监理工程师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册建造师" prop="regConstrTotal">
                    <Input-number :min="0" v-model="guarantorModel.regConstrTotal" placeholder="请输入注册建造师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册造价师" prop="regCostTotal">
                    <Input-number :min="0" v-model="guarantorModel.regCostTotal" placeholder="请输入注册造价师人数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="6">
                  <Form-item label="项目经理" prop="prjManagerTotal">
                    <Input-number :min="0" v-model="guarantorModel.prjManagerTotal" placeholder="请输入项目经理人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="注册会计师" prop="cpaTotal">
                    <Input-number :min="0" v-model="guarantorModel.cpaTotal" placeholder="请输入注册会计师人数"></Input-number>
                  </Form-item>
                </Col>
                <Col span="6">
                  <Form-item label="律师" prop="solicitorTotal">
                    <Input-number :min="0" v-model="guarantorModel.solicitorTotal" placeholder="请输入律师人数"></Input-number>
                  </Form-item>
                </Col>
              </Row>
              <div class="clearfix"></div>
            </div>
          </Form-item>
          <Form-item label="企业简介" prop="description">
            <Input v-model="guarantorModel.introduction" placeholder="请输入企业简介" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item>
          <Form-item label="担保经营范围" prop="guarRange">
            <Input v-model="guarantorModel.guarRange" placeholder="请输入担保经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
          </Form-item>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写业务联系人', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, message: '请填写业务联系电话', trigger: 'blur' }
        ]
      },
      cities: []
    }
  },
  watch: {
    '$route.params.guarantorId': function () {
      this.getGuarantorDetail()
    }
  },
  mounted () {
    this.getGuarantorDetail()
    this.initCitySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getGuarantorDetail () {
      Api.Guarantor.getGuarantorDetail(this.$route.params.guarantorId).then((res) => {
        Object.assign(this.guarantorModel, res)
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.guarantorModel.regCity = val[val.length - 1]
      } else {
        this.guarantorModel.regCity = val
      }
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Guarantor.updateGuarantor(this.guarantorModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
</style>
